import React from "react";
import './loader.css'

const Loader = () => {
  return (
   <div className="loaderOverlay">
      <img 
        src="/Purecarats-Loader.gif" 
        alt="Loading..." 
        className="loaderLogo"
      />
    </div>

  );
};

export default Loader;
